import React, { useEffect, useState } from 'react';

// Define the list of messages with optional Twitter links
const messages = [
  {
    text: "Stop chasing.\n\nIt’ll come to you.\n\nIt’ll fall right into your lap.\n\nWhen the time is right, you’ll know it.",
    author: "ipex 🐔🧲",
    link: "https://x.com/ipextrades/status/1855795864603877522",
  },
  {
    text: "I won’t let circumstance determine my stance",
    author: "illuminaticongo ✖️",
    link: "https://x.com/illuminaticongo/status/1854861976133918961",
  },
  { text: "One good thing about music, when it hits you, you feel no pain", author: "Bob Marley" },
  { text: "Music can change the world because it can change people", author: "Bono" },
  { text: "Without music, life would be a mistake", author: "Friedrich Nietzsche" },
  { text: "Where words fail, music speaks", author: "Hans Christian Andersen" },
  { text: "Music is the universal language of mankind", author: "Henry Wadsworth Longfellow" },
  { text: "Music is a higher revelation than all wisdom and philosophy", author: "Ludwig van Beethoven" },
  { text: "Music gives a soul to the universe, wings to the mind, flight to the imagination, and life to everything", author: "Plato" },
  { text: "People haven’t always been there for me, but music always has", author: "Taylor Swift" },
  { text: "Music is the strongest form of magic", author: "Marilyn Manson" },
  { text: "Music expresses that which cannot be said and on which it is impossible to be silent", author: "Victor Hugo" },
  { text: "Music is my religion", author: "Jimi Hendrix" },
  { text: "Music in the soul can be heard by the universe", author: "Lao Tzu" },
  { text: "Music touches us emotionally, where words alone can’t", author: "Johnny Depp" },
  { text: "Music produces a kind of pleasure which human nature cannot do without", author: "Confucius" },
  { text: "Music is the wine that fills the cup of silence", author: "Robert Fripp" },
  { text: "Music was my refuge. I could crawl into the space between the notes and curl my back to loneliness", author: "Maya Angelou" },
  { text: "Life seems to go on without effort when I am filled with music", author: "George Eliot" },
  { text: "Music is a world within itself, with a language we all understand", author: "Stevie Wonder" },
  { text: "After silence, that which comes nearest to expressing the inexpressible is music", author: "Aldous Huxley" },
  { text: "The only truth is music", author: "Jack Kerouac" },
  { text: "You can’t knock on opportunity’s door and not be ready", author: "Bruno Mars" },
  { text: "The moment I start having fun, I’ll be successful. Making money is not what drives me; it’s doing what I love", author: "Ed Sheeran" },
  { text: "Believe in your flyness, conquer your shyness", author: "Kanye West" },
  { text: "Work hard in silence, let your success be your noise", author: "Frank Ocean" },
  { text: "My main goal is to stay as real as I can and make the music that’s true to me", author: "H.E.R." },
  { text: "Being creative is about turning nothing into something", author: "Pharrell Williams" },
  { text: "Stay true to yourself, yet always be open to learn", author: "Kendrick Lamar" },
  { text: "Art is an extension of my soul, it’s a way to connect with the world", author: "The Weeknd" },
  { text: "You have to create your own path. Nobody’s gonna make a path for you", author: "Jay-Z" },
  { text: "If you’re passionate about something, you should keep going. Nothing’s out of reach", author: "Khalid" },
];

const RandomMessage = ({ trigger }) => {
  const [randomMessage, setRandomMessage] = useState(
    messages[Math.floor(Math.random() * messages.length)]
  );

  useEffect(() => {
    // Update the message only when `trigger` changes
    setRandomMessage(messages[Math.floor(Math.random() * messages.length)]);
  }, [trigger]);

  return (
    <div style={{ textAlign: 'center', padding: '20px', maxWidth: '500px', margin: '0 auto' }}>
      <a
        href={randomMessage.link || "#"} // Only adds a link if provided
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: randomMessage.link ? 'underline' : 'none', color: 'inherit' }}
      >
        <h2 style={{
          fontSize: '1.1em', // Slightly smaller font size for compact look
          margin: '0', 
          lineHeight: '1.1', // Tighter line height for minimal vertical spacing
          whiteSpace: 'pre-line'
        }}>
          {randomMessage.text}
        </h2>
        <p style={{ 
          color: 'gray', 
          fontSize: '0.9em', // Smaller font for author name
          marginTop: '10px' // Adjusted margin for spacing between text and author
        }}>
          — {randomMessage.author}
        </p>
      </a>
    </div>
  );
};

export default RandomMessage;
